<p-table stripedRows #dtARContract
    [value]="items"
    dataKey="Contractlistid"
    editMode="row"
    [scrollable]="true"
    scrollHeight="50vh"
    [style]="{ 'min-width': '100%' }"
    sortField="Contractdesc"
    [sortOrder]="1"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="4" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>
    <ng-template #header let-item>
        <tr>
            <!-- Edit -->
            <th class="edit-cell"></th>
            <!-- status-->
            <th class="status-cell">
                <i
                    class="pi pi-exclamation-circle"
                    title="Status"
                ></i>
            </th>
            <!-- Contract -->
            <th pSortableColumn="Contractdesc">
                Contract
                <p-sortIcon
                    pSortableColumn="Contractdesc"
                    field="Contractdesc"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" field="Contractdesc" display="menu" class="ml-auto" />
            </th>
            <!-- Account -->
            <th pSortableColumn="Accountcode">
                Account
                <p-sortIcon
                    pSortableColumn="Accountcode"
                    field="Accountcode"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item let-edit="editing" let-ri="rowIndex">
        <tr
            [pSelectableRow]="item"
            [pEditableRow]="item"
            data-id="row-{{ item.Contractlistid }}"
        >
        <!-- Edit -->
            <td class="edit-cell">
                <button
                    *ngIf="
                        !edit &&
                        (!editing?.Contractlistid ||
                            editing?.Contractlistid ===
                                item?.Contractlistid)
                    "
                    pButton
                    type="button"
                    pInitEditableRow
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text"
                    (click)="onRowEditInit(item)"
                    title="Edit"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pSaveEditableRow
                    icon="pi pi-check"
                    class="p-button-rounded p-button-text p-button-success"
                    (click)="onRowEditSave(item)"
                ></button>
                <button
                    *ngIf="edit"
                    pButton
                    type="button"
                    pCancelEditableRow
                    icon="pi pi-times"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="onRowEditCancel(item)"
                ></button>
            </td>
            <!-- Status-->
            <td class="status-cell">
                <div (click)="onStatusClick(item)" class="status-cell">
                    <ef-status-icon
                        [status]="item?.Status?.StatusCode"
                        [message]="item?.Status?.Message"
                    ></ef-status-icon>
                </div>
            </td>
            <!-- Contract -->
            <td class="disabled">
                {{ item?.Contractdesc }}
            </td>
            <!-- Account -->
            <td>
                <p-cellEditor>
                    <ng-template pTemplate="input">
                        <p-select
                            [autoDisplayFirst]="false"
                            appendTo="body"
                            [options]="accounts"
                            [filter]="true"
                            [(ngModel)]="item.Araccountlistid"
                        ></p-select>
                    </ng-template>
                    <ng-template pTemplate="output">
                        <div
                            data-toggle="tooltip"
                            data-placement="top"
                            [attr.title]="item.Accountcode"
                        >
                            {{ item.Accountcode }}
                        </div>
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
</p-table>
